import { appendUtmParams } from '../../../../utils/url';

const buildShopifyCheckoutRedirectUrl = (checkoutUrl) => appendUtmParams(checkoutUrl);

export default buildShopifyCheckoutRedirectUrl;
